import { ChatStreamUpdateMode } from './chatProtocolAdapters';

const VisualStreamIdleMs = 600;
const VisualStreamChunkLength = 24;
const VisualStreamIntervalMs = 45;

const getVisualStreamChunks = (text = '') => {
    const tokens = text.match(/\S+\s*|\s+/g) || [];
    const chunks = [];
    let currentChunk = '';

    tokens.forEach((token) => {
        if (currentChunk && currentChunk.length + token.length > VisualStreamChunkLength) {
            chunks.push(currentChunk);
            currentChunk = token;
            return;
        }

        currentChunk = `${currentChunk}${token}`;
    });

    if (currentChunk) chunks.push(currentChunk);
    return chunks;
};

export const createVisualStreamController = ({ onReconciliationBlockedChange, onStreamUpdate }) => {
    let isCancelled = false;
    let streamPromise = Promise.resolve();
    let chunkTimeoutId = null;
    let idleTimeoutId = null;
    let updateSequence = 0;

    const clearChunkTimeout = () => {
        if (!chunkTimeoutId) return;
        clearTimeout(chunkTimeoutId);
        chunkTimeoutId = null;
    };

    const clearIdleTimeout = () => {
        if (!idleTimeoutId) return;
        clearTimeout(idleTimeoutId);
        idleTimeoutId = null;
    };

    const scheduleIdleRelease = () => {
        const currentSequence = updateSequence + 1;
        updateSequence = currentSequence;
        clearIdleTimeout();

        streamPromise.then(() => {
            if (isCancelled || updateSequence !== currentSequence) return;

            idleTimeoutId = setTimeout(() => {
                if (updateSequence !== currentSequence) return;
                idleTimeoutId = null;
                onReconciliationBlockedChange(false);
            }, VisualStreamIdleMs);
        });
    };

    const enqueue = (streamTextUpdate) => {
        onReconciliationBlockedChange(true);

        if (streamTextUpdate.mode === ChatStreamUpdateMode.REPLACE) {
            streamPromise = streamPromise.then(() => {
                if (isCancelled) return;
                onStreamUpdate?.(streamTextUpdate);
            });
            scheduleIdleRelease();
            return;
        }

        const chunks = getVisualStreamChunks(streamTextUpdate.text);
        streamPromise = streamPromise.then(() => {
            return new Promise((resolveVisualStream) => {
                const streamNextChunk = () => {
                    if (isCancelled || !chunks.length) {
                        chunkTimeoutId = null;
                        resolveVisualStream();
                        return;
                    }

                    onStreamUpdate?.({
                        mode: ChatStreamUpdateMode.APPEND,
                        text: chunks.shift(),
                    });

                    chunkTimeoutId = setTimeout(streamNextChunk, VisualStreamIntervalMs);
                };

                streamNextChunk();
            });
        });
        scheduleIdleRelease();
    };

    const cancel = () => {
        isCancelled = true;
        clearChunkTimeout();
        clearIdleTimeout();
        onReconciliationBlockedChange(false);
    };

    return {
        cancel,
        enqueue,
        waitForIdle: () => streamPromise,
    };
};
